import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Toggle from 'react-toggle';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

class StaffScheduleRequestsSigmecAdd extends Component {
  
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      errors_listing: false,
      loaded: 0,
      list_staffs: [],
      list_schedules: [],
      data: {},
      errors_messages: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.addLine = this.addLine.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.loadData = this.loadData.bind(this);
    this.save = this.save.bind(this);
    this.saveImages = this.saveImages.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, index, event) {
    var change = this.state.data;
    change[index][name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, index, event) {
    var change = this.state.data;
    if (event.target.checked === true) {
      var value = 1;
    } else {
      change[index]['date_finish'] = null;
      var value = 0;
    }
    change[index][name] = value;
    this.setState(change);
  } 
  
  handleSelectChange(name, index, event) {
    var change = this.state.data;
    if(event == null) {
      change[index][name] = null;
    } else {
      change[index][name] = event.value;
    }
    this.setState(change);
  }

  handleSelectScheduleChange(name, index, event) {
    var change = this.state.data;
    var self = this;
    change[index]['staff_id'] = null;
    change[index]['change_type'] = null;
    if(event == null) {
      change[index][name] = null;
    } else {
      self.setState({overlay: {message: '', type: '', status: 'open'}});
      change[index][name] = event.value;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api_sigmec') + '/colaboradores/escala/lista/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.setState({
              list_staffs: responseJson.data,
            });
          }
          change[index]['list_staffs'] = responseJson.data;
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }); /* Overlay */
      });
    }

    this.setState(change);
  }
  handleSelectChangeType(name, index, event) {
    var change = this.state.data;
    change[index]['definitive_change'] = false;
    change[index]['date_finish'] = null;
    change[index]['current_base_id'] = null;
    change[index]['current_role_id'] = null;
    change[index]['current_group_id'] = null;
    change[index]['current_regime_id'] = null;
    change[index]['current_schedule_period_id'] = null;
    change[index]['new_base_id'] = null;
    change[index]['new_role_id'] = null;
    change[index]['new_group_id'] = null;
    change[index]['new_regime_id'] = null;
    change[index]['new_schedule_period_id'] = null;
    change[index]['warning_message'] = null;
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    if(event == null) {
      change[index][name] = null;
      self.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      change[index][name] = event.value;
      var datasave = {
        staff_id: this.state.data[index].staff_id,
        schedule_id: this.state.data[index].schedule_id,
        change_type: event.value,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/colaboradores/escala/tipo/alteracao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            change[index]['current_base_id'] = responseJson.data.current_base_id;
            change[index]['current_role_id'] = responseJson.data.current_role_id;
            change[index]['list_current_groups'] = responseJson.data.list_current_groups;
            change[index]['list_schedule_groups'] = responseJson.data.list_schedule_groups;
            change[index]['list_current_regimes'] = responseJson.data.list_current_regimes;
            change[index]['regimes_select'] = responseJson.data.regimes_select;
            change[index]['list_base'] = responseJson.data.list_current_bases;
            change[index]['list_bases'] = responseJson.data.list_bases;
            change[index]['list_current_schedule_periods'] = responseJson.data.list_current_schedule_periods;
            change[index]['list_schedule_periods'] = responseJson.data.list_schedule_periods;
            change[index]['list_current_roles'] = responseJson.data.list_current_roles;
            change[index]['list_roles'] = responseJson.data.list_roles;
          }
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var id = null;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api_sigmec') + '/escala/solicitacao';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
            self.setState({list_schedules: responseJson.data.list_schedules});
            self.setState({list_change_types: responseJson.data.list_change_types});
            self.addLine();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  // Deleta uma linha de período do modal
  deleteLine(deleted_index) {
    var self = this;
    var new_data = {};
    var x = 0;
    Object.keys(self.state.data).map(function(k) {
      if(deleted_index !== k) {
        new_data[x] = self.state.data[k];
        x++;
      }
    })
    this.setState({data: new_data})
  }

  // Adiciona uma linha de período do modal
  addLine() {
    var self = this;
    var x = 0;
    var new_data = self.state.data
    Object.keys(self.state.data).map(function(k) {
      x++;
    });
    new_data[x] = {
      staff_id: null,
      schedule_id: null,
      change_type: null,
      definitive_change: false,
      current_schedule_period_id: null,
      new_schedule_period_id: null,
      current_role_id: null,
      new_role_id: null,
      request_number: null,
      mp_number: null,
      current_group_id: null,
      new_group_id: null,
      current_regime_id: null,
      new_regime_id: null,
      current_base_id: null,
      new_base_id: null,
      description: null,
      date_start: null,
      date_finish: null,
      reason: null,
      lists: {},
    };

    this.setState({data: new_data})
  }

  saveImages() {
    var self = this;
    {Object.keys(self.state.data).map(function(k) {
      if(self.state.data[k].change_type == 'change_absences') {
        var data = new FormData();
        var imagedata = document.querySelector('.input-absense-justify-' + k).files[0];
        data.append("imagem", imagedata);
        data.append("id", self.state.change_absences_ids[k]);
        
        var header = self.refs.request_api.header();
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api_sigmec') + '/escala/solicitacao/imagem', {
            method: 'POST',
            mode: 'cors',
            headers: value,
            body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
            }).catch((error) => {
            console.error(error);
          });
        });
            
      } 
    })};
    var url = '/funcionario/escala/solicitacoes/sigmec';
    this.setState({redirect_url: url});
   
  }

  save() {
    var self = this;
    if(window.confirm('Tem certeza de que deseja criar estas solicitações?')) {
      this.setState({overlay: {message: '', type: '', status: 'open'}});

      var datasave = {};
      {Object.keys(self.state.data).map(function(k) {
        if(self.state.data[k].change_type == 'change_absences') {
          var imagedata = document.querySelector('.input-absense-justify-' + k).files[0];
          datasave[k] = {
            imagem: imagedata,
            staff_id: self.state.data[k].staff_id,
            schedule_id: self.state.data[k].schedule_id,
            change_type: self.state.data[k].change_type,
            definitive_change: self.state.data[k].definitive_change,
            current_schedule_period_id: self.state.data[k].current_schedule_period_id,
            new_schedule_period_id: self.state.data[k].new_schedule_period_id,
            current_role_id: self.state.data[k].current_role_id,
            new_role_id: self.state.data[k].new_role_id,
            request_number: self.state.data[k].request_number,
            mp_number: self.state.data[k].mp_number,
            current_group_id: self.state.data[k].current_group_id,
            new_group_id: self.state.data[k].new_group_id,
            current_regime_id: self.state.data[k].current_regime_id,
            new_regime_id: self.state.data[k].new_regime_id,
            current_base_id: self.state.data[k].current_base_id,
            new_base_id: self.state.data[k].new_base_id,
            description: self.state.data[k].description,
            date_start: self.state.data[k].date_start,
            date_finish: self.state.data[k].date_finish,
            reason: self.state.data[k].reason,
          };
            
        } else {
          datasave[k] = {
            staff_id: self.state.data[k].staff_id,
            schedule_id: self.state.data[k].schedule_id,
            change_type: self.state.data[k].change_type,
            definitive_change: self.state.data[k].definitive_change,
            current_schedule_period_id: self.state.data[k].current_schedule_period_id,
            new_schedule_period_id: self.state.data[k].new_schedule_period_id,
            current_role_id: self.state.data[k].current_role_id,
            new_role_id: self.state.data[k].new_role_id,
            request_number: self.state.data[k].request_number,
            mp_number: self.state.data[k].mp_number,
            current_group_id: self.state.data[k].current_group_id,
            new_group_id: self.state.data[k].new_group_id,
            current_regime_id: self.state.data[k].current_regime_id,
            new_regime_id: self.state.data[k].new_regime_id,
            current_base_id: self.state.data[k].current_base_id,
            new_base_id: self.state.data[k].new_base_id,
            description: self.state.data[k].description,
            date_start: self.state.data[k].date_start,
            date_finish: self.state.data[k].date_finish,
            reason: self.state.data[k].reason,
          };
        
        }
      })};
      
      var data = JSON.stringify(datasave)
      
      var header = this.refs.request_api.header('application/json');

      Promise.resolve(header).then(function(value) {
        fetch(config.get('api_sigmec') + '/escala/solicitacao', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {     
              var url = '/funcionario/escala/solicitacoes/sigmec';
              var storage = {
                alert_message: responseJson.message,
                alert_type: responseJson.status,
              };
              localStorage.setItem("verify_message", JSON.stringify(storage));

              //Se der certo o save, e precisarmos salvar imagem
              //executamos um método para salvar as imagens que enviamos
              if(responseJson.data.send_images === true) {
                //Ids que usaremos para salvar
                self.setState({change_absences_ids: responseJson.data.change_absences_ids});
                self.saveImages();

              } else {
                self.setState({redirect_url: url});
              }
            }  else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
              self.setState({errors_messages: responseJson.data, errors_listing: true});
            }
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
          }).catch((error) => {
          console.error(error);
        });
      });
    }
  }



  render() {
    var self = this;

    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.titulo}</h3>
      <Link to="/escala/solicitacoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
            <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <div className="table-responsive">
        <table className="table table-bordered table-schedule-requests table-hover table-striped" style={{width:"250px", height: "400px"}}>
          <thead>
            <tr>
              <th style={{width:"250px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.EscalaMesAtual}</th>
              <th style={{width:"350px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Colaborador}</th>
              <th style={{width:"250px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.TipoDeAlteracao}</th>
              <th style={{width:"150px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.DataDeInicio}</th>
              <th style={{width:"150px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.DataDeTermino}</th>
              <th style={{width:"150px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Duracao}</th>
              <th style={{width:"350px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Justificativa}</th>
              <th style={{width:"200px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Atual}</th>
              <th style={{width:"200px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Novo}</th>
              <th style={{width:"200px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.NumeroChamado}</th>
              <th style={{width:"200px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.NumeroMp}</th>
              <th style={{width:"200px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Atestado}</th>
              <th style={{width:"200px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Descricao}</th>
              <th style={{width:"60px"}} className="text-center">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Acoes}</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(self.state.data).map(function(k) {
              return (
                <tr>
                  <td>
                    <Select
                    className=""
                    name="schedule_id"
                    value={self.state.data[k].schedule_id}
                    placeholder={'Selecione uma escala'}
                    onChange={self.handleSelectScheduleChange.bind(self, 'schedule_id', k)}
                    options={self.state.list_schedules}
                    required
                    />
                  </td>
                  <td>
                    <Select
                    className=""
                    name="staff_id"
                    value={self.state.data[k].staff_id}
                    placeholder={'Selecione um colaborador'}
                    onChange={self.handleSelectChange.bind(self, 'staff_id', k)}
                    options={self.state.data[k].list_staffs}
                    required
                    />
                  </td>
                  <td>
                    <Select
                    className=""
                    name="change_type"
                    value={self.state.data[k].change_type}
                    placeholder={'Selecione um tipo de alteração'}
                    onChange={self.handleSelectChangeType.bind(self, 'change_type', k)}
                    options={self.state.list_change_types}
                    required
                    />
                  </td>
                  <td>
                    <InputMask value={self.state.data[k].date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'date_start', k)} placeholder="" required />
                  </td>
                  {((self.state.data[k].change_type == 'change_group' || self.state.data[k].change_type == 'change_base' || self.state.data[k].change_type == 'change_role' || self.state.data[k].change_type == 'change_absences') && self.state.data[k].definitive_change == false) ? 
                    <td>
                      <InputMask value={self.state.data[k].date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={self.handleChange.bind(self, 'date_finish', k)} placeholder="" required />
                    </td>
                  : <td></td>
                  }
                  {(self.state.data[k].change_type == 'change_group' || self.state.data[k].change_type == 'change_base' || self.state.data[k].change_type == 'change_role' || self.state.data[k].change_type == 'change_absences') ? 
                    <td>
                      <Toggle
                        checked={self.state.data[k].definitive_change}
                        aria-label='No label tag'
                        name="definitive_change"
                        onChange={self.handleToggleChange.bind(self, 'definitive_change', k)} 
                      />
                    </td>
                  : <td></td>
                  }
                  <td>
                    <input type="text" value={self.state.data[k].reason} name="reason" className="form-control" onChange={self.handleChange.bind(self, 'reason', k)} placeholder="" required />
                  </td>
                  <td>
                    {(self.state.data[k].change_type == 'change_group') ? 
                        <Select
                        className=""
                        name="current_group_id"
                        value={self.state.data[k].current_group_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneGrupo}
                        onChange={self.handleSelectChange.bind(self, 'current_group_id', k)}
                        options={self.state.data[k].list_current_groups}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_regime') ?
                        <Select
                        className=""
                        name="current_regime_id"
                        value={self.state.data[k].current_regime_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneQuinzena}
                        onChange={self.handleSelectChange.bind(self, 'current_regime_id', k)}
                        options={self.state.data[k].list_current_regimes}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_base') ?
                        <Select
                        className=""
                        name="current_base_id"
                        value={self.state.data[k].current_base_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneBase}
                        onChange={self.handleSelectChange.bind(self, 'current_base_id', k)}
                        options={self.state.data[k].list_base}
                        required
                        disabled
                        />
                      : (self.state.data[k].change_type == 'change_period') ?
                        <Select
                        className=""
                        name="current_schedule_period_id"
                        value={self.state.data[k].current_schedule_period_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecionePeriodo}
                        onChange={self.handleSelectChange.bind(self, 'current_schedule_period_id', k)}
                        options={self.state.data[k].list_current_schedule_periods}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_role') ?
                        <Select
                        className=""
                        name="current_role_id"
                        value={self.state.data[k].current_role_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneFuncao}
                        onChange={self.handleSelectChange.bind(self, 'current_role_id', k)}
                        options={self.state.data[k].list_current_roles}
                        required
                        />
                      : ''
                    }
                  </td>
                  <td>
                    {(self.state.data[k].change_type == 'change_group') ? 
                        <Select
                        className=""
                        name="new_group_id"
                        value={self.state.data[k].new_group_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneGrupo}
                        onChange={self.handleSelectChange.bind(self, 'new_group_id', k)}
                        options={self.state.data[k].list_schedule_groups}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_regime') ?
                        <Select
                        className=""
                        name="new_regime_id"
                        value={self.state.data[k].new_regime_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneQuinzena}
                        onChange={self.handleSelectChange.bind(self, 'new_regime_id', k)}
                        options={self.state.data[k].regimes_select}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_base') ?
                        <Select
                        className=""
                        name="new_base_id"
                        value={self.state.data[k].new_base_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneBase}
                        onChange={self.handleSelectChange.bind(self, 'new_base_id', k)}
                        options={self.state.data[k].list_bases}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_period') ?
                        <Select
                        className=""
                        name="new_schedule_period_id"
                        value={self.state.data[k].new_schedule_period_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecionePeriodo}
                        onChange={self.handleSelectChange.bind(self, 'new_schedule_period_id', k)}
                        options={self.state.data[k].list_schedule_periods}
                        required
                        />
                      : (self.state.data[k].change_type == 'change_role') ?
                        <Select
                        className=""
                        name="new_role_id"
                        value={self.state.data[k].new_role_id}
                        placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneFuncao}
                        onChange={self.handleSelectChange.bind(self, 'new_role_id', k)}
                        options={self.state.data[k].list_roles}
                        required
                        />
                      : ''
                    }
                  </td>
                  {(self.state.data[k].change_type == 'change_role' && self.state.data[k].definitive_change == false) ? 
                    <td>
                      <input type="text" name="request_number" className="form-control" required placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.NumeroChamado} value={self.state.data[k].request_number} onChange={self.handleChange.bind(self, 'request_number', k)} />
                    </td>
                  : <td></td>
                  }
                  {(self.state.data[k].change_type == 'change_role' && self.state.data[k].definitive_change == true) ? 
                    <td>
                      <input type="text" name="mp_number" className="form-control" required placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.NumeroMp} value={self.state.data[k].NumeroMp} onChange={self.handleChange.bind(self, 'mp_number', k)} />
                    </td>
                  : <td></td>
                  }
                  {self.state.data[k].change_type == 'change_absences' ? 
                    <td>
                      <input type="file" name="absense_justify" className={"form-control input-absense-justify-" + k} placeholder={self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.Atestado} value={self.state.data[k].absense_justify} onChange={self.handleChange.bind(self, 'absense_justify', k)} />
                    </td>
                    : <td></td>
                  }
                  {self.state.data[k].change_type == 'other_changes' ? 
                    <td>
                      <input type="text" value={self.state.data[k].description} name="description" className="form-control" onChange={self.handleChange.bind(self, 'description', k)} placeholder="" required />
                    </td>
                    : <td></td>
                  }
                  <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center'}}>
                    <button onClick={() => {self.deleteLine(k);}} type="button" className="btn btn-danger"><i className="fa fa-fw fa-close"></i></button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="row">
        <div className="col-md-6">
          <button onClick={() => {self.save();}} className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> {self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.botaoSalvarSolicitacoes}</button>
        </div>
        <div className="col-md-6">
          <button onClick={() => {self.addLine();}} className="btn btn-block btn-success"><i className="fa fa-fw fa-plus"></i> {self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.botaoAdicionarSolicitacao}</button>
        </div>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default StaffScheduleRequestsSigmecAdd;



// WEBPACK FOOTER //
// ./src/Components/StaffScheduleRequests/StaffScheduleRequestsSigmecAdd.js